import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEOHead from "../components/head"

import FeatureBar from "../components/common/feature-bar"
import Hero from "../components/hero"
import CardListWithIcon from "../components/sections/card-list-with-icon"
import CardSection from "../components/sections/card-section"
import CardListSlider from "../components/sections/card-list-slider"

export default function HomeTemplate({ pageContext, data }) {
  const { wpPage, allWpNews, allWpCommunity, wordpressAcfOptions } = data
  const startTrading =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.startTrading

  const viewVideo =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.viewVideo

  const backgroundVideoUrl = wordpressAcfOptions.themeGeneralSettings.themeSettings.heroBackgroundVideo

  console.log(wordpressAcfOptions.themeGeneralSettings.themeSettings.heroBackgroundVideo)

  return (
    <Layout page={pageContext}>
      <Hero
        data={wpPage}
        startTrading={startTrading}
        viewVideo={viewVideo}
        backgroundVideoUrl={backgroundVideoUrl}
      />

      <div className="container relative z-10 mx-auto -mb-10 -translate-y-1/2">
        <div className="relative padding-x-10">
          <FeatureBar
            data={
              wordpressAcfOptions.themeGeneralSettings.themeSettings.featureBar
            }
          />
        </div>
      </div>

      <div className="overflow-hidden">
        <div className="container mx-auto my-12 md:my-[70px] space-y-12 md:space-y-[88px]">
          {wpPage.flexibleContent.flexibleContent &&
            wpPage.flexibleContent.flexibleContent.map((flexContent, i) => {
              switch (flexContent.fieldGroupName) {
                case "Page_Flexiblecontent_FlexibleContent_CardListWithIcon":
                  return (
                    <div
                      className="padding-x-10 section-fadein-up"
                      key={`section-${i}`}
                    >
                      <CardListWithIcon data={flexContent} />
                    </div>
                  )

                case "Page_Flexiblecontent_FlexibleContent_CardSection":
                  return (
                    <div className="section-fadein-up" key={`section-${i}`}>
                      <CardSection data={flexContent} />
                    </div>
                  )

                // case "Page_Flexiblecontent_FlexibleContent_CardListSlider":
                //   return (
                //     <div className="padding-x-10 section-fadein-up" key={`section-${i}`}>
                //       <CardListSlider
                //         data={flexContent}
                //         news={allWpNews}
                //         communities={allWpCommunity}
                //       />
                //     </div>
                //   )

                default:
                  return null
              }
            })}
        </div>
      </div>
    </Layout>
  )
}
export const Head = ({ data }) => {
  return <SEOHead data={data.wpPage.seo} />
}
export const query = graphql`
  query PageQuery($slug: String!, $locale: String) {
    wpPage(slug: { eq: $slug }, locale: { locale: { eq: $locale } }) {
      ...PageSeo
      ...WpPageFragment
      flexibleContent {
        ...WpPage_FlexiblecontentFragment
      }
      featuredImage {
        node {
          gatsbyImageData(width: 2560)
        }
      }
    }

    wordpressAcfOptions(locale: { eq: $locale }) {
      themeGeneralSettings {
        themeSettings {
          heroBackgroundVideo
          startTrading {
            target
            title
            url
          }
          viewVideo {
            target
            title
            url
          }
          featureBar {
            title
            icon {
              altText
              mediaItemUrl
            }
          }
        }
      }
    }

    allWpNews(limit: 3, sort: { date: DESC }) {
      nodes {
        title
        excerpt
        uri
        featuredImage {
          node {
            gatsbyImageData(width: 500)
          }
        }
      }
    }

    allWpCommunity(limit: 3, sort: { date: DESC }) {
      nodes {
        content
        communities {
          author {
            ... on WpPerson {
              person {
                occupation
              }
              title
              featuredImage {
                node {
                  gatsbyImageData(width: 100)
                }
              }
            }
          }
        }
      }
    }
  }
`
